(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-slider')) {
    customElements.define(
      'video-slider',
      class VideoSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.video-slider__track');
          this.prev = this.querySelector('.video-slider__button--prev');
          this.next = this.querySelector('.video-slider__button--next');
          if (!this.track) return;

          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateButtons());
          this.updateButtons();

          // Autoplay (pauses while hovering / touching / focused)
          if (this.dataset.autorotate === 'true') {
            this.speed = parseInt(this.dataset.autorotateSpeed, 10) || 5000;
            this.start();
            ['mouseenter', 'touchstart', 'focusin'].forEach((e) =>
              this.addEventListener(e, () => this.stop(), { passive: true })
            );
            ['mouseleave', 'touchend', 'focusout'].forEach((e) =>
              this.addEventListener(e, () => this.start(), { passive: true })
            );
          }

          // Theme editor: scroll to the block being edited
          document.addEventListener('shopify:block:select', (event) => {
            const slide = this.track.querySelector('#Slide-' + event.detail.blockId);
            if (!slide) return;
            this.stop();
            this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          });
        }

        step() {
          const item = this.track.querySelector('.video-slider__item');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        }

        atEnd() {
          return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 5;
        }

        go(direction) {
          if (direction > 0 && this.atEnd()) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
          }
        }

        updateButtons() {
          const noScroll = this.track.scrollWidth <= this.track.clientWidth + 5;
          this.prev.disabled = noScroll || this.track.scrollLeft <= 5;
          this.next.disabled = noScroll || (this.atEnd() && this.dataset.autorotate !== 'true');
        }

        start() {
          this.stop();
          this.timer = setInterval(() => this.go(1), this.speed);
        }

        stop() {
          clearInterval(this.timer);
        }

        disconnectedCallback() {
          this.stop();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
